import React, { useEffect, useState } from "react";
import {
  DateInput,
  RadioInput,
  SelectInput,
} from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction } from "../../../_store";
import { fDate, MinDate, Today } from "../../../utils/formatTime";
import Button from "./../../../components/common/ui/Button";
import { useLocation } from "react-router-dom";
import generateInmateMessagePDF from "./../../../components/common/export/Reports/generateInmateMessagePDF";
import CustomLoader from "../../../components/common/ui/Loader";
import loaddataimg from "../../../assets/svg/load-data.svg";

const Inmates = ({ loadData, render }) => {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { facilityDropDown } = useSelector((x) => x.master);
  const { requestType } = useSelector((x) => x.dropdownOptions);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);
  const {
    RequestFormType,
    InitiateMessageRecords,
    loading,
    initiateMessage,
    inmate,
  } = useSelector((x) => x.inmate);

  useEffect(() => {
    setAllowDownload(loadData);
    dispatch(
      inmateAction.setInitiateMessgae({
        FacilityID:
          Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
        InmatesId: Inmate?.InmateID || inmate?.InmateID,
        RequestFormTypeID: 0,
        ManagementUserID: user?.ManagementUserID,
        DobStartDate: "",
        DobEndDate: "",
      })
    );
  }, [render]);

  useEffect(() => {
    if (InitiateMessageRecords?.length > 0) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [InitiateMessageRecords]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (Inmate?.facilityID || inmate?.facilityID) {
      dispatch(
        inmateAction.GetFacilityRequestFormType({
          facilityId:
            Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
        })
      );

      dispatch(
        inmateAction.setInitiateMessgae({
          ...initiateMessage,
          FacilityID:
            Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
          InmatesId: Inmate?.InmateID || inmate?.InmateID,
          ManagementUserID: user?.ManagementUserID,
        })
      );
      // setInmates({
      //   ...inmates,
      //   FacilityID: Inmate?.facilityID,
      //   InmatesId: Inmate?.InmateID,
      // });
    }
  }, [Inmate || inmate]);

  const FacilityName = facilityDropDown?.find(
    (item) => item?.value === parseInt(commonFacilityCode)
  )?.label;

  // const [inmates, setInmates] = useState({
  //   FacilityID: Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
  //   InmatesId: Inmate?.InmateID || inmate?.InmateID,
  //   RequestFormTypeID: 0,
  //   ManagementUserID: user?.ManagementUserID,
  //   DobStartDate: "",
  //   DobEndDate: "",
  // });

  const [allowDownload, setAllowDownload] = useState(false);
  const [disable, setDisable] = useState(false);

  const handleDateChange = (value, name) => {
    const date = fDate(value);

    dispatch(
      inmateAction.setInitiateMessgae({
        ...initiateMessage,
        [name]: date,
      })
    );

    // setInmates((prev) => ({
    //   ...prev,
    //   [name]: date,
    // }));
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && initiateMessage[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "DobStartDate") {
      if (
        initiateMessage.DobEndDate &&
        new Date(value) > new Date(initiateMessage.DobEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "DobEndDate") {
      if (
        initiateMessage.DobStartDate &&
        new Date(value) < new Date(initiateMessage.DobStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...initiateMessage,
      DobStartDate:
        fieldName === "DobStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : initiateMessage.DobStartDate, // preserve existing value
      DobEndDate:
        fieldName === "DobEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : initiateMessage.DobEndDate, // preserve existing value
    };
    dispatch(inmateAction.setInitiateMessgae(updatedParam));
  };

  const handleSelectChange = (selectedOption, name) => {
    dispatch(
      inmateAction.setInitiateMessgae({
        ...initiateMessage,
        [name]: parseInt(selectedOption?.value ?? 0),
      })
    );

    // setInmates((prev) => ({
    //   ...prev,
    //   [name]: parseInt(selectedOption?.value),
    // }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAllowDownload(true);
    dispatch(inmateAction.LoadRequestMGUserThreadInmateExport(initiateMessage));
  };

  const handleDownload = (e) => {
    // Sample Data
    e.preventDefault();

    const title = "Message to Inmate";

    const MessagesData = InitiateMessageRecords?.map((obj) => ({
      Title: obj?.RequestTitle,
      PODCode: obj?.PodCode || "-",
      CreatedOn: obj?.ReqestCreateDate || "N/A",
      Request: obj?.RequestBody || "N/A",
      SentDateTime: obj?.ReqestPostDate || "N/A",
      PostedBy: obj?.RequestRespondBy || "N/A",
      RequestForumMGUserThreadID: obj?.RequestForumMGUserThreadID || "N/A",
    }));

    const Name = "Admin Super";
    const ResidantID = Inmate?.InmateResidentId || inmate?.InmateResidentId;

    generateInmateMessagePDF(Name, ResidantID, MessagesData, title);

    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearInitiateMessageRecords());
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearInitiateMessageRecords());
  };

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <>
      <div className="d-none" id="output"></div>
      <div className=" p-2 ">
        <h4 className="inner-header-bg text-color">
          {" "}
          <i className="fa-solid fa-filter me-2"></i>Filter{" "}
        </h4>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row ">
            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={RequestFormType}
                  value={initiateMessage?.RequestFormTypeID}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "RequestFormTypeID")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={disable}
                  isLoading={false}
                  isClearable={initiateMessage?.RequestFormTypeID}
                  placeholder="Select Type"
                  label="Type"
                />
              </div>
            </div>
            {/* Row for From Date */}

            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={initiateMessage?.DobStartDate}
                  handleChange={(e) => handleDateChange(e, "DobStartDate")}
                  name="DobStartDate"
                  label="From Date"
                  maxDate={
                    initiateMessage?.DobEndDate
                      ? initiateMessage?.DobEndDate
                      : new Date()
                  }
                  required={false}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  className={false ? "disabled-date-input" : ""} // Conditional class
                  isClearable={initiateMessage?.DobStartDate}
                  preventClear={!initiateMessage?.DobStartDate}
                  minDate={new Date(2017, 0, 1)}
                  handleBlur={(e) => handleDateBlur(e, "DobStartDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "DobStartDate")}
                />
              </div>
            </div>
            {/* Row for To Date */}
            <div className="col-sm-6 col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={initiateMessage?.DobEndDate}
                  handleChange={(e) => handleDateChange(e, "DobEndDate")}
                  name="DobEndDate"
                  // Set minDate to FromDate
                  minDate={
                    initiateMessage?.DobStartDate
                      ? initiateMessage?.DobStartDate
                      : new Date(2017, 0, 1)
                  }
                  label="To Date"
                  maxDate={new Date()}
                  required={false}
                  disabled={disable}
                  yearDropDown={false}
                  monthDropDown={false}
                  isClearable={initiateMessage?.DobEndDate}
                  preventClear={!initiateMessage?.DobEndDate}
                  handleBlur={(e) => handleDateBlur(e, "DobEndDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "DobEndDate")}
                />
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex flex-wrap gap-3">
            {InitiateMessageRecords &&
              InitiateMessageRecords?.length > 0 &&
              allowDownload && (
                <div className="d-flex flex-wrap align-items-start">
                  <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                    Data loaded successfully. Click download button to export
                    PDF.
                  </label>
                </div>
              )}

            {InitiateMessageRecords &&
              InitiateMessageRecords?.length === 0 &&
              allowDownload && (
                <div className="d-flex flex-wrap align-items-start">
                  <label className="font-size-16 fw-bold text-danger">
                    No Data Available
                  </label>
                </div>
              )}

            <div className="d-flex flex-wrap ms-auto">
              {InitiateMessageRecords?.length === 0 && (
                <Button
                  className="me-2"
                  label={"LOAD DATA"}
                  type={"submit"}
                  status={"btn-label"}
                  imgsrc={loaddataimg}
                  disabled={false}
                ></Button>
              )}
              {InitiateMessageRecords?.length > 0 && allowDownload && (
                <>
                  <Button
                    className="me-2"
                    label={"CANCEL"}
                    type={"submit"}
                    icon={"fa-solid fa-xmark"}
                    variant="danger"
                    status={"primary"}
                    disabled={false}
                    onClick={handleCancel}
                  />
                  <Button
                    className="me-2"
                    label={"Download"}
                    icon={"fa-solid fa-download"}
                    type={"button"}
                    status={"success"}
                    disabled={false}
                    onClick={(e) => handleDownload(e)}
                  ></Button>
                </>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default React.memo(Inmates);
